import { PERMISSION_GRAPHQL, SERVICE_UUID } from './config';
import { invokeGraphQL } from './graphql';
import gql from 'nanographql';
import useLoader from "./use-loader";

export const Permissions = [
  {
    key: 'Manage Updates',
    cascade: true,
    defaultValue: true
  },
  {
    key: 'View Pending Product Instances',
    cascade: true,
    defaultValue: true
  },
  {
    key: 'View Product Instances',
    cascade: true,
    defaultValue: true
  },
  {
    key: 'View Customers',
    cascade: true,
    defaultValue: true
  },
  {
    key: 'View Users',
    cascade: true,
    defaultValue: true
  },
  {
    key: 'View Map',
    cascade: true,
    defaultValue: true
  },
  {
    key: 'View Inspector',
    cascade: true,
    defaultValue: true
  },
  {
    key: 'View Comm',
    cascade: true,
    defaultValue: true
  },
  {
    key: 'View Reports',
    cascade: true,
    defaultValue: true
  },
  {
    key: 'View Applications',
    cascade: true,
    defaultValue: true
  },
  {
    key: 'View Application Permissions',
    cascade: true,
    defaultValue: true
  },
  {
    key: 'View Application Instances',
    cascade: true,
    defaultValue: true
  },
  {
    key: 'View Application Versions',
    cascade: true,
    defaultValue: true
  },
  {
    key: 'Manage Permissions',
    cascade: true,
    defaultValue: true
  }
];

const MANAGE_PERMISSIONS = gql`
  mutation managePermissions($service: UUID!, $permissions: [ManagedPermissionInput!]!) {
      manage(service: $service, permissions: $permissions)
  }
`;

export function useManage(options = {}) {
  return useLoader(
    manage,
    {
      ...options,
      permission: "Manage Permissions"
    }
  );
}

export async function manage() {
  return invokeGraphQL(
    PERMISSION_GRAPHQL,
    MANAGE_PERMISSIONS,
    {
      service: SERVICE_UUID,
      permissions: Permissions
    }
  );
}



// WEBPACK FOOTER //
// ./src/services/managed-permissions.js